// import { ICMS, ICMSIMAGE } from "../screens/home/homeModel";

export const decodeHtml = (html: string) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  const decodedHtml = txt.value;

  return decodedHtml.replace(/^<p>(.*?)<\/p>$/s, "$1");
};

export const getTicketPrice = (date: string): number => {
  if (!date) return 0;
  const selectedDate = new Date(date);
  const day = selectedDate.getDay();
  return day === 0 || day === 6 ? 1000 : 900;
};

export const getBreakdown = (date: string, passengers: number) => {
  const inclusivePrice = getTicketPrice(date);
  const totalInclusive = inclusivePrice * passengers;

  const basePerTicket = inclusivePrice / 1.18;
  const baseTotal = basePerTicket * passengers;

  const cgst = baseTotal * 0.09;
  const sgst = baseTotal * 0.09;

  const perTicket = inclusivePrice;
  const grandTotal = totalInclusive;

  return { perTicket, cgst, sgst, grandTotal };
};

export function formatIndianNumber(number: number, decimal: any = 2): string {
  if (number === null || number === undefined) return "";
  let [integerPart, decimalPart] = number.toFixed(decimal).split(".");
  let lastThreeDigits = integerPart.slice(-3);
  let otherDigits = integerPart.slice(0, -3);

  if (otherDigits !== "") {
    lastThreeDigits = "," + lastThreeDigits;
  }

  let formattedOtherDigits = otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
  return formattedOtherDigits + lastThreeDigits + "." + decimalPart;
}

export function createLookupObject<
  T extends Record<string, any>,
  K extends keyof T,
>(array: T[], key: K): Record<T[K] & (string | number | symbol), T> {
  const lookup: Record<string | number | symbol, T> = {};

  for (const item of array) {
    lookup[item[key] as any] = item;
  }

  return lookup as Record<T[K] & (string | number | symbol), T>;
}

// export const processCMSContent = (cms: ICMS): string => {
//   if (!cms?.Template) return "";

//   let processedContent = decodeHtml(cms.Template);

//   if (cms.cms_image_details && cms.cms_image_details.length > 0) {
//     cms.cms_image_details.forEach((img: ICMSIMAGE) => {
//       const imgNameParts = img.Name?.split("-");
//       const imgIdentifier = imgNameParts?.length
//         ? imgNameParts[imgNameParts.length - 1]
//         : img.Name;
//       // Handle different types of image placements based on identifier
//       if (imgIdentifier === "bg") {
//         // For background images (identified with "b")
//         processedContent = processedContent.replace(
//           `id="${img.Name}">`,
//           `id="${img.Name}" style="background-image:url('${img.Image}')">`,
//         );
//       } else {
//         // For regular content images
//         // Create a more specific pattern to avoid replacing multiple times
//         const placeholderPattern = new RegExp(
//           `id="${img.Name}">\\s*</div>`,
//           "g",
//         );
//         processedContent = processedContent.replace(
//           placeholderPattern,
//           `id="${img.Name}"><img src="${img.Image}" alt="${
//             img.AltName || ""
//           }" class="img-fluid" /></div>`,
//         );
//       }
//     });
//   }
//   return processedContent;
// };

export const calculateReadingTime = (
  text: string,
  wordsPerMinute = 150,
): string => {
  if (!text) return "1 min read";

  // Remove HTML tags if present
  const cleanText = text.replace(/<[^>]*>/g, "");

  // Count words (split by spaces and filter out empty strings)
  const wordCount = cleanText
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0).length;

  // Calculate reading time in minutes
  const minutes = Math.ceil(wordCount / wordsPerMinute);

  // Return formatted string
  return `${Math.max(1, minutes)} min read`;
};

/**
 * Normalizes phone numbers for UI display, ensuring they have at most one leading '+' prefix,
 * and handles cleaning up consecutive/extra '+' signs.
 */
export const formatPhoneForDisplay = (phone: string): string => {
  if (!phone) return "";
  
  // Trim white spaces
  let cleaned = phone.trim();
  
  // Replace multiple leading '+' symbols with a single '+'
  cleaned = cleaned.replace(/^\++/, "+");
  
  return cleaned;
};

/**
 * Standardizes phone numbers for telephone links (tel:), ensuring only digits and a single
 * leading '+' (if the original number started with one or more '+') are kept.
 */
export const cleanPhoneForTel = (phone: string): string => {
  if (!phone) return "";
  
  const trimmed = phone.trim();
  const hasPlus = trimmed.startsWith("+");
  const digits = trimmed.replace(/\D+/g, "");
  
  return hasPlus ? `+${digits}` : digits;
};

